import { useQuery } from "@tanstack/react-query";
import { getPosterStatistics } from "../../api/posters";
import "./PosterStatusBar.css";

interface PosterStatusBarProps {
    showTakenDown: boolean;
    onShowTakenDownChange: (show: boolean) => void;
}

const fmt = (n: number) => new Intl.NumberFormat("sv-SE").format(n);

export const PosterStatusBar = ({
    showTakenDown,
    onShowTakenDownChange
}: PosterStatusBarProps): JSX.Element | null => {
    // Siffrorna spänner över alla kampanjer man har åtkomst till – samma urval som
    // affischlagret ritar ut, och samma som admin-statistiken redan visar.
    const { data: stats } = useQuery({
        queryKey: ["posters", "statistics"],
        queryFn: () => getPosterStatistics(),
        refetchInterval: 30_000,
        staleTime: 15_000
    });

    if (!stats) return null;

    return (
        <div className="poster-status-bar" role="status" aria-label="Affischstatistik">
            <span className="poster-status-bar__icon" aria-hidden="true">🪧</span>
            <div className="poster-status-bar__stat">
                <span className="poster-status-bar__label">Teamet idag</span>
                <span className="poster-status-bar__value">{fmt(stats.teamTodayCount)} st</span>
            </div>
            <div className="poster-status-bar__divider" />
            <div className="poster-status-bar__stat">
                <span className="poster-status-bar__label">Uppe nu</span>
                <span className="poster-status-bar__value">{fmt(stats.teamTotalCount)} st</span>
            </div>
            <div className="poster-status-bar__divider" />
            <div className="poster-status-bar__stat">
                <span className="poster-status-bar__label">Nedtagna</span>
                <span className="poster-status-bar__value">{fmt(stats.teamTakenDownCount)} st</span>
            </div>
            {stats.teamVandalizedCount > 0 && (
                <>
                    <div className="poster-status-bar__divider" />
                    <div className="poster-status-bar__stat">
                        <span className="poster-status-bar__label">Vandaliserade</span>
                        <span className="poster-status-bar__value">{fmt(stats.teamVandalizedCount)} st</span>
                    </div>
                </>
            )}
            {stats.myTodayCount > 0 && (
                <>
                    <div className="poster-status-bar__divider" />
                    <div className="poster-status-bar__stat">
                        <span className="poster-status-bar__label">Jag idag</span>
                        <span className="poster-status-bar__value">{fmt(stats.myTodayCount)} st</span>
                    </div>
                </>
            )}
            <label className="poster-status-bar__toggle">
                <input
                    type="checkbox"
                    checked={showTakenDown}
                    onChange={(e) => onShowTakenDownChange(e.target.checked)}
                />
                Visa nedtagna
            </label>
        </div>
    );
};
